import React from "react";

const VaultsAndRankingPage = () => {
  return (
    <section>
      <p>
        Collateral Vaults, Queue Ordering & Ranking Mechanics A collateral vault
        is the foundational economic unit of USCY. Each time an eligible
        customer mints USCY, the cash deposit is placed into a new, dedicated
        collateral vault. This vault: Joins the front of the redemption queue
        (LIFO entry) Receives a period of temporary protection to prevent
        immediate closure Begins accruing rewards tied to its deposit Vaults
        exist independently of token flows and determine how long a depositor
        continues earning rewards. 1. What is a vault? Every vault records: USD
        principal deposited Accrued rewards Time created Amount of YPPs
        allocated to influence queue position A unique vault ID A position in
        the global redemption queue Vaults are not wallets and do not hold USCY
        tokens. They represent the depositor&apos;s economic rights within the
        trust. 2. How vaults are created A. Every mint creates a new vault Each
        mint operation results in: Creation of a new vault Placement of the
        vault at the front of the redemption queue Application of temporary
        protection until the next reward cycle Immediate start of reward accrual
        Vaults are never topped up or combined. Each deposit forms its own
        lifecycle. 3. Queue position and temporary protection New vaults always
        enter at the front of the queue. Temporary protection ensures newly
        created vaults are not immediately used to satisfy redemptions. During
        this period, the vault owner may: Assess queue dynamics Decide whether
        to allocate YPPs Position the vault according to their strategy After
        protection ends, the vault becomes fully eligible according to normal
        queue rules. 4. The redemption queue All open vaults exist in a single,
        globally ordered redemption queue. High-level structure: Front → nearest
        to closure; shortest remaining duration Middle → moderate duration;
        neutral zone Rear → furthest from closure; longest remaining duration
        Queue position determines when a vault may be closed to fund
        redemptions. 5. What determines queue order? Queue order is governed by
        three factors: A. Entry rule New vaults always enter at the front of the
        queue. B. YPP influence Vault owners may spend YPPs to move a vault
        further back, extending its expected duration. C. Chronological ordering
        when YPP influence is equal When two or more vaults have equal or no
        YPPs applied: Ranking is determined by chronological order —
        last-in-first-out (LIFO). The newer vault sits ahead of the older vault.
        6. Ranking mechanics Each vault is assigned: A numerical ranking (e.g.,
        position #48 of 7,932) A queue band (Front / Middle / Rear) A record of
        YPPs applied to influence position Ranking determines: How soon a vault
        may be closed How much remaining duration the vault might have Whether
        additional YPPs may be beneficial Ranking is unaffected by: Token
        transfers Trading activity OES settlement flows Wallet movements Vault
        mechanics are independent of token mobility. 7. Queue bands To simplify
        queue navigation, vaults are grouped into: Front Band Vaults nearest to
        closure; limited remaining duration. Middle Band Moderate distance from
        closure; neutral risk. Rear Band Longest remaining duration; most
        protected. These bands help vault owners instantly understand relative
        position. 8. Queue drift Vault movement depends on the net balance
        between mints and redemptions. A. Contraction (redemptions exceed mints)
        Vaults move toward the front Remaining duration shortens Strategic
        vaults may require YPPs for protection B. Expansion (mints exceed
        redemptions) New vaults constantly enter at the front Older vaults
        naturally move backwards Duration increases without intervention C. YPP
        overrides Vault owners can override natural drift at any time by
        allocating YPPs to reposition vaults. 9. YPP and ranking Spending YPPs
        on a vault allows the owner to reposition that vault further back in the
        queue. Process: Select vault Select YPP amount Preview new ranking
        Confirm Vault moves backward YPP spend: Is deterministic and rule-based
        Does not affect yield rate Does not affect redemption rights Does not
        alter the USCY peg It affects timing only. 10. Vault lifecycle A. Open
        Vault is created Temporarily protected Accrues rewards Ranking evolves
        due to drift, YPP use, and market conditions B. Closure When an eligible
        customer redeems USCY: The vault at the front is closed Its rewards
        cease Its principal is used to fulfil redemption It is removed
        permanently from the queue C. Final Closed vaults do not reappear in the
        UI or influence future queue dynamics. 11. Multi-vault strategies
        Because every mint creates a new vault, sophisticated customers often
        manage portfolios of vaults, enabling: Duration layering Selective YPP
        allocation Separation of operational vs strategic vaults OES-specific
        vault management Rebalancing during contraction or expansion periods
        This enables institutions to tailor queue exposure precisely to their
        workflow needs. 12. Summary Every mint creates a new vault. Vaults enter
        at the front with temporary protection. Queue position determines
        duration. Drift depends on mint/redemption balance. YPPs allow vault
        owners to manage duration actively. Vault closure ends the yield window
        for that vault. USCY&apos;s vault-and-ranking model delivers:
        Predictable economics, transparent timing, and market-based duration
        optionality.
      </p>
    </section>
  );
};

export default VaultsAndRankingPage;
